import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { converAttrToDatagridCol, CustomDatagridEditCell, datatypes, inputTypes } from "data/globalData";
import { totalSizeRatioColumn } from "../../data";
import { convertSizeStringToStandardInputFormat, orderQtyStaticColumns } from "../data";

import { Box, Typography, Stack } from "@mui/material";
import DisplayTable from "components/ReusableComponents/DisplayTable";

const ChannelCutQtySizeLevel = ({
	tableColumns = [],
	channel,
	channelQtyData,
	handleDataChange,
	allChannels,
	allSizes,
	editMode = false,
}) => {
	const tableRowsState = channelQtyData.filter((row) => row.channel === channel);

	const handleRowDataChange = (newRow, oldRow) => {
		return handleDataChange(newRow, oldRow, channel);
	};

	const sizeQtyDisplayColumns = [
		{
			name: "Size",
			key: "size",
			data_type: datatypes.STRING.key,
			input_type: inputTypes.ENTER.key,
		},
		{
			name: " Qty",
			key: "cut_qty",
			data_type: datatypes.STRING.key,
			input_type: inputTypes.ENTER.key,
			editable: true,
		},
	];

	return (
		<Stack width="300px" spacing={2}>
			<Box>
				<Typography variant="h6" mr={2}>
					Cut Qty - {channel}
				</Typography>
				<DataGrid
					rows={tableRowsState ? tableRowsState : []}
					getRowId={(row) => row.id}
					columns={sizeQtyDisplayColumns.map((col) => converAttrToDatagridCol(col))}
					sx={{
						width: "100%",
						// maxHeight: 250,
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-row:hover": {
							backgroundColor: "transparent",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[400],
							textTransform: "uppercase",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					}}
					density="compact"
					disableRowSelectionOnClick
					pagination={false} // Remove footer
					hideFooter={true}
					showCellVerticalBorder
					showColumnVerticalBorder
					isCellEditable={({ row }) => editMode}
					processRowUpdate={handleRowDataChange}
					autoHeight
				/>
			</Box>
		</Stack>
	);
};

export default ChannelCutQtySizeLevel;
